import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { createCustomPolygon as addPolygon } from '@api/map';

import { ICustomPolygonDTO } from '@interfaces/map/dto/polygonDTO';

import { ESnackbarTypes } from '@enums/common';

import { CUSTOM_POLYGON } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateAddPolygon = (onSuccessCallback: (data: ICustomPolygonDTO) => void) => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutateAsync: createCustomPolygon,
		isLoading: isCreatingCustomPolygon,
	} = useMutation({
		mutationKey: [CUSTOM_POLYGON],
		mutationFn: addPolygon,
		onSuccess: (data: ICustomPolygonDTO) => {
			dispatch(setSnackbar({
				message: responseMessages.createdPolygon,
				type: ESnackbarTypes.success,
			}));

			onSuccessCallback(data);

			return queryClient.invalidateQueries([CUSTOM_POLYGON]);
		},
	});

	return {
		createCustomPolygon,
		isCreatingCustomPolygon,
	};
};
